import { isObject } from '../../components/common-functions';
import type { Disposable } from '../interfaces/disposable.interface';

export function isDisposable(object: unknown): object is Disposable {
  return isObject(object) && 'dispose' in object;
}

export function areDisposable(objects: Array<unknown>): objects is Array<Disposable> {
  return Array.isArray(objects) && objects.length > 0 && objects.every((object) => isDisposable(object));
}
